<template>
    <div>
        <div class="review-box">
            <div v-for="item,index in dataList" :key="index">

                <div class="comment-card">
                    <div class="comment-people">
                        <div style="display:flex;align-items: center;">
                            <div class="circle">{{item.covey_calendar.covey_user.realname[0]}}</div>
                            <span>{{item.covey_calendar.covey_user.realname}}</span>
                        </div>
                        <div class="main-title-right">
                            <img :src="require('@/assets/icon/star.png')" />
                            <span>{{item.rate}}</span>
                        </div>
                    </div>
                    <div class="comment-content">{{item.content}}</div>
                    <div class="comment-time">{{format(item.comment_time)}}</div>
                </div>
                <!-- <div class="reply-card" v-if="item.is_reply!==0">
                    <div class="reply-content">{{item.replied_content}}</div>
                </div> -->
            </div>
        </div>

        <div v-if="defaultParmas.page<page_count" class="see-more" @click="seeMore">
            <div>SEE MORE <i class="el-icon-arrow-down"></i></div>
        </div>
    </div>
</template>

<script>
import { format } from "@/utils/comm";
export default {
    props: ['courseId'],
    data() {
        return {

            defaultParmas: {
                page: 1,
                limit: 5
            },
            dataList: [],
            count: 0,
            format: format,
            page_count: 0,
        }
    },
    mounted() {
        this.$nextTick(()=>{
            this.getCourseCommentList();
        })
    },
    methods: {


        getCourseCommentList() {
            let params = { ...this.defaultParmas, cId: this.courseId }
            this.$api.courseApi.getCourseCommentList(params).then(res => {
                if (res.status === "0") {
                    this.dataList = res.data.rows;
                    this.page_count = Math.ceil(res.data.count / this.defaultParmas.limit);
                }
            });
        },

        seeMore() {
            this.defaultParmas.page++;
            let params = { ...this.defaultParmas, cId: this.courseId }
            this.$api.courseApi.getCourseCommentList(params).then(res => {
                if (res.status === "0") {
                    this.dataList = this.dataList.concat(res.data.rows);
                }
            })
        }

    }

}
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";

.review-box {
    position: relative;
    .comment-card {
        padding: 32px 0;
        border-bottom: 1px solid rgba(126, 128, 136, 0.16);
        // background: #fff;
        // box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
        // border-radius: 8px;

        .comment-people {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .circle {
                width: 32px;
                height: 32px;
                background: #fecb3e;
                color: #fff;
                font-size: 18px;
                font-weight: 600;
                line-height: 32px;
                border-radius: 50%;
                margin-right: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
        .comment-content {
            // height: 60px;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #201002;
            line-height: 24px;
            margin: 16px 0 0 40px;
        }
        .comment-time {
            text-align: left;
            height: auto;
            font-size: 14px;
            font-weight: 600;
            color: #b7b2ae;
            line-height: 30px;
            margin: 8px 0 0 40px;
        }
        .main-title-right {
            padding: 6px 16px;
            border-radius: 24px;
            background: rgba(252, 233, 209, 0.54);
            img {
                width: 12px;
                height: 12px;
                margin-right: 4px;
            }
        }
    }
    .reply-card {
        width: 100%;
        margin-top: 16px;
        display: flex;
        justify-content: flex-end;
        .reply-content {
            width: 520px;
            background: #e4e4e4;
            padding: 16px;
            box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
            border-radius: 8px;
            line-height: 30px;
            color: #201002;
            font-weight: 600;
        }
    }
}
.see-more {
    cursor: pointer;
    float: right;
    font-size: 14px;
    line-height: 20px;
    color: #201002;
    margin-top: 16px;
}
</style>